import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "no-image-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "image-container" }, {
    default: _withCtx(() => [
      (_ctx.imageSrc)
        ? (_openBlock(), _createBlock(_component_v_img, {
            key: 0,
            class: "image-centered",
            src: this.imageSrc
          }, null, 8, ["src"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, " Sem imagem de exemplo "))
    ]),
    _: 1
  }))
}